export const TestHooks = {
	AgreementDateDatePicker: 'agreement-date-date-picker',
	RequisitionDateDatePicker: 'requisition-date-date-picker',
	OccupancyDateDatePicker: 'occupancy-date-date-picker',
	ClosingDateDatePicker: 'closing-date-date-picker',
	AppointmentDateDatePicker: 'appointment-date-date-picker',
	LocationSpecified: 'location-specified',
	RegionSpecified: 'region-specified',
	ClientExecutingLocation: 'client-executing-location',
	ClientExecutingLocationSpecified: 'client-executing-location-specified',
	ClientExecutingRegion: 'client-executing-region',
	ClientExecutingRegionSpecified: 'client-executing-region-specified',
	CommissionerName: 'commissioner-name',
	CommissionerEmail: 'commissioner-email',
	CommissionerPhoneNumber: 'commissioner-phone-number',
	WitnessName: 'witness-name',
	WitnessEmail: 'witness-email',
	WitnessPhoneNumber: 'witness-phone-number',
	ExecutingLocationSelect: 'executing-location-select',
	ExecutingRegionSelect: 'executing-region-select',
	ButtonSegmented: 'button-segmented',
	ButtonSegmented1: 'button-segmented-1',
	LocationTypeOption: 'location-type-option',
	SigningRegionTypeOption: 'signing-region-type-option',
	SaveButton: 'save-button',
} as const;
